import { MenuItem } from '@material-ui/core';
import TextInput from 'components/TextInput/TextInput';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArchiveProjectDialog } from 'scenes/Project/components/ArchiveProjectDialog/ArchiveProjectDialog';

const PROJECT_STATUSES = ['ESTIMATING', 'IN_PROGRESS', 'WARRANTY_PERIOD'];

// Archiving is the last status of an existing project (short-term projects
// have their own statuses). Picking it asks for confirmation first; like
// every status it is saved with the dialog, and picking another status takes
// the project out of the archive.
const canArchiveProject = (dialogType, projectType) =>
  dialogType === 'edit' && projectType !== 'SHORT_TERM';

export const ProjectStatusSelect = ({
  value,
  onChange,
  dialogType,
  projectType,
  isPermissionToEditStatus,
  loading,
}) => {
  const { t } = useTranslation('common');

  const [isArchiveConfirmationOpen, setIsArchiveConfirmationOpen] =
    useState(false);

  const statuses =
    value === 'ARCHIVED' || canArchiveProject(dialogType, projectType)
      ? [...PROJECT_STATUSES, 'ARCHIVED']
      : PROJECT_STATUSES;

  const handleChange = (e) => {
    const status = e.target.value;

    if (status === 'ARCHIVED' && value !== 'ARCHIVED') {
      setIsArchiveConfirmationOpen(true);
      return;
    }

    onChange(status);
  };

  const handleArchiveConfirmed = () => {
    setIsArchiveConfirmationOpen(false);
    onChange('ARCHIVED');
  };

  return (
    <>
      <TextInput
        fullWidth
        select
        label={t('project_dialog.field_project_status')}
        name="status"
        value={value}
        onChange={handleChange}
        disabled={
          loading || (dialogType === 'edit' && !isPermissionToEditStatus)
        }
      >
        {statuses.map((status) => (
          <MenuItem key={status} value={status}>
            {t(`project_dialog.project_status.${status}`)}
          </MenuItem>
        ))}
      </TextInput>
      {isArchiveConfirmationOpen ? (
        <ArchiveProjectDialog
          closeArchiveProjectDialog={() => setIsArchiveConfirmationOpen(false)}
          handleArchiveProject={handleArchiveConfirmed}
        />
      ) : null}
    </>
  );
};
